var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('van-nav-bar',{attrs:{"title":_vm.givenTitle}})],1),_c('main',[_c('router-view')],1),_c('footer')])
}
var staticRenderFns = []

export { render, staticRenderFns }